//import * as chart from 'chart.js'
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

let dispGraph = null
let shearGraph = null
let momentGraph = null

export function showResultCharts(jsonData) {
  document.getElementById('plot-panel-area').classList.remove('d-none')
  let dys = getData("dy", jsonData)
  if(dispGraph) { dispGraph.destroy() }
  dispGraph = showPlot(dys, 'beam-disp-graph')

  let vys = getData("vy", jsonData)
  vys = vys.map( vy => {
    return {x: vy.x, y: vy.y / 1000}
  })
  if(shearGraph) { shearGraph.destroy() }
  shearGraph = showPlot(vys, 'beam-shear-graph')

  let mzs = getData("mz", jsonData)
  mzs = mzs.map( mz => {
    return {x: mz.x, y: mz.y / 1000 / 12}
  })
  if(momentGraph) { momentGraph.destroy() }
  momentGraph = showPlot(mzs, 'beam-moment-graph')
}

function showPlot(points, element) {
  let data = {
    datasets: [{
      data: points,
      backgroundColor: 'rgb(255, 99, 132)',
      showLine: true,
      tension: 0.0,
      pointRadius: 4,
      borderWidth: 5
    }],
  };
  
  let ctx = document.getElementById(element).getContext('2d');

  return new Chart(ctx, {
    type: 'scatter',
    data: data,
    options: {
      scales: {
        x: {
          type: 'linear',
          position: 'bottom',
          ticks: {
            beginAtZero: true,
            max: 100
          },
          min: 0,
          max: points[points.length - 1].x
        },
      },
      plugins: {
        legend: {
          display: false,
        } 
      } 
    },
  })
}

function getData(item, data) {
  var d1 = []
  var x_offset = 0
  var x = 0
  for (let elem = 0; elem < data.internal_forces.x.length; elem++) {
    x_offset += x;
    var xl = data.internal_forces.x[elem];
    var rl = data.internal_forces[item][elem];
    for (var i = 0; i < xl.length; i++) {
      x = Number(xl[i]);
      d1.push({x: x + x_offset, y: Number(Number(rl[i]).toFixed(4))})
    }
  }
  return d1
}
